import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import { createPageUrl } from '@/utils';
// import { base44 } from '@/api/base44Client';
import {
    LayoutDashboard,
    FolderCog,
    Download,
    LogOut,
    User,
    Users,
    Bell,
    FileText
} from 'lucide-react';
import { Button } from "./components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./components/ui/dropdown-menu";
import { useAuth } from './context/AuthContext';

const base44 = { auth: { logout: () => console.log('logout') } }; // Mock for now

export default function Layout({ children, currentPageName }) {
    const { user } = useAuth();
    const location = useLocation();

    const isAdmin = user?.role === 'admin';

    // Helper because createPageUrl is missing in the snippets provided
    const createPageUrl = (page) => {
        switch (page) {
            case 'Dashboard': return '/dashboard';
            case 'AdminFolders': return '/admin/folders';
            case 'AdminAlerts': return '/admin/alerts';
            case 'AdminUsers': return '/admin/users';
            case 'AdminTerms': return '/admin/terms';
            case 'AlertReceiver': return '/admin/receiver';
            default: return '/';
        }
    };

    // Pages that have their own full layout
    const fullPageLayouts = ['Dashboard', 'AdminFolders', 'AlertReceiver', 'AdminUsers', 'AdminAlerts', 'AdminTerms', 'tradingview-alerts'];

    // Note: Since we are likely wrapping this inside the router/app structure, checking currentPageName might need adjustment based on how props are passed. 
    // For now I'll assume we want this floating menu to appear on specific routes.

    return (
        <div className="min-h-screen bg-slate-900">
            {children}
        </div>
    );

}
